import { CardContent } from '@src/components/Editor/types'

interface TDeleteNestedComments {
  orderedComments: CardContent[]
  entityKeys: string[]
  commentId: string
}
export function deleteNestedComments({
  orderedComments,
  entityKeys,
  commentId,
}: TDeleteNestedComments): string[] {
  let nextIndex = orderedComments.findIndex(c => c.id === commentId) + 1
  let nextComment = nextIndex < orderedComments.length && orderedComments[nextIndex]
  const ids = []
  // while nextComment is nested inside original comment
  while (nextComment && nextComment.entityKeys.every(k => entityKeys.includes(k))) {
    ids.push(nextComment.id)
    nextIndex++
    nextComment = nextIndex < orderedComments.length && orderedComments[nextIndex]
  }
  return ids
}



// WEBPACK FOOTER //
// ./src/state/document/helpers/comment.helper.ts